import { useState } from 'react'
import { useBrandColors } from '../../hooks/useBrandColors'

const DAYS = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
const MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December']

const eventTypes = {
  company:     { label:'Company Event',   color:'#4A7C59', bg:'rgba(74,124,89,0.1)'   },
  pto:         { label:'My PTO',          color:'#8A6640', bg:'rgba(217,195,163,0.3)' },
  deadline:    { label:'Deadline',        color:'#A0392B', bg:'rgba(160,57,43,0.1)'   },
  reminder:    { label:'Personal',        color:'#4A6B8A', bg:'rgba(217,195,163,0.15)'  },
  birthday:    { label:'Birthday',        color:'#B8734A', bg:'rgba(184,115,74,0.1)'  },
  anniversary: { label:'Anniversary',     color:'#6B7D6B', bg:'rgba(107,125,107,0.15)'},
}

const initialEvents = [
  { id:1,  date:'2025-04-02', type:'company',     title:'All-Staff Meeting',               time:'9:00 AM',  note:'Conference Room A' },
  { id:2,  date:'2025-04-02', type:'deadline',    title:'Timesheet Due - Week 13',          time:'5:00 PM',  note:'Submit before EOD' },
  { id:3,  date:'2025-04-05', type:'birthday',    title:'Kim Park - Birthday',              time:'',         note:'' },
  { id:4,  date:'2025-04-07', type:'deadline',    title:'Safety Training Module 2 Due',     time:'5:00 PM',  note:'Complete in portal' },
  { id:5,  date:'2025-04-10', type:'company',     title:'Q1 Review - All Departments',      time:'1:00 PM',  note:'Zoom link in memo' },
  { id:6,  date:'2025-04-12', type:'anniversary', title:'Sam Rivera - 3 Year Anniversary',  time:'',         note:'' },
  { id:7,  date:'2025-04-14', type:'company',     title:'Spring Schedule Starts',           time:'8:00 AM',  note:'New hours: 8am-4pm' },
  { id:8,  date:'2025-04-15', type:'deadline',    title:'PTO Policy Sign-off Due',          time:'5:00 PM',  note:'Review in Documents' },
  { id:9,  date:'2025-04-18', type:'deadline',    title:'Timesheet Due - Week 15',          time:'5:00 PM',  note:'' },
  { id:10, date:'2025-04-22', type:'company',     title:'Employee Appreciation Week Starts',time:'',         note:'April 22-26' },
  { id:11, date:'2025-04-23', type:'pto',         title:'My PTO - Vacation',                time:'All Day',  note:'Approved' },
  { id:12, date:'2025-04-24', type:'pto',         title:'My PTO - Vacation',                time:'All Day',  note:'Approved' },
  { id:13, date:'2025-04-25', type:'pto',         title:'My PTO - Vacation',                time:'All Day',  note:'Approved' },
  { id:14, date:'2025-04-28', type:'birthday',    title:'Jordan Collins - Birthday',        time:'',         note:'' },
  { id:15, date:'2025-04-30', type:'deadline',    title:'Monthly Report Submission',        time:'5:00 PM',  note:'To Tiffany Gallagher' },
  { id:16, date:'2025-05-01', type:'anniversary', title:'Jamie Mitchell - 2 Year Anniversary',time:'',      note:'' },
  { id:17, date:'2025-05-05', type:'company',     title:'Team Lunch',                       time:'12:00 PM', note:'Downtown Grill' },
  { id:18, date:'2025-05-09', type:'deadline',    title:'Timesheet Due - Week 18',          time:'5:00 PM',  note:'' },
]

export default function Calendar() {
  const { accent, accentBg } = useBrandColors()
  const [view, setView] = useState('month')
  const [year, setYear] = useState(2025)
  const [month, setMonth] = useState(3) // 0-indexed, April
  const [weekStart, setWeekStart] = useState(new Date(2025, 3, 6)) // week of Apr 6
  const [events, setEvents] = useState(initialEvents)
  const [selectedDay, setSelectedDay] = useState(null)
  const [showAddModal, setShowAddModal] = useState(false)
  const [showDayModal, setShowDayModal] = useState(false)
  const [newEvent, setNewEvent] = useState({ title:'', date:'', time:'', note:'', type:'reminder' })
  const [filterTypes, setFilterTypes] = useState(Object.keys(eventTypes))

  const today = '2025-04-02'

  function prevMonth() {
    if (month === 0) { setMonth(11); setYear(y => y-1) }
    else setMonth(m => m-1)
  }
  function nextMonth() {
    if (month === 11) { setMonth(0); setYear(y => y+1) }
    else setMonth(m => m+1)
  }
  function prevWeek() { setWeekStart(d => { const n = new Date(d); n.setDate(n.getDate()-7); return n }) }
  function nextWeek() { setWeekStart(d => { const n = new Date(d); n.setDate(n.getDate()+7); return n }) }

  function eventsOn(dateStr) {
    return events.filter(e => e.date === dateStr && filterTypes.includes(e.type))
  }

  function getDaysInMonth(y, m) {
    return new Date(y, m+1, 0).getDate()
  }
  function getFirstDayOfMonth(y, m) {
    return new Date(y, m, 1).getDay()
  }

  function dateStr(y, m, d) {
    return `${y}-${String(m+1).padStart(2,'0')}-${String(d).padStart(2,'0')}`
  }

  function handleDayClick(ds) {
    setSelectedDay(ds)
    setShowDayModal(true)
  }

  function handleAddEvent() {
    if (!newEvent.title || !newEvent.date) return
    setEvents(ev => [...ev, { ...newEvent, id: Date.now() }])
    setShowAddModal(false)
    setNewEvent({ title:'', date:'', time:'', note:'', type:'reminder' })
  }

  function toggleFilter(type) {
    setFilterTypes(ft => ft.includes(type) ? ft.filter(t => t !== type) : [...ft, type])
  }

  const upcomingDeadlines = events
    .filter(e => e.type === 'deadline' && e.date >= today)
    .sort((a,b) => a.date.localeCompare(b.date))
    .slice(0, 3)

  const inputStyle = { width:'100%', padding:'8px 12px', border:'1px solid #EDE6DA', borderRadius:6, fontSize:12, fontFamily:"'Montserrat',sans-serif", outline:'none', boxSizing:'border-box' }
  const labelStyle = { display:'block', fontSize:9, textTransform:'uppercase', letterSpacing:'0.1em', color:'#6B7D6B', fontWeight:600, marginBottom:5 }

  // Build month grid
  const firstDay = getFirstDayOfMonth(year, month)
  const daysInMonth = getDaysInMonth(year, month)
  const daysInPrev = getDaysInMonth(year, month === 0 ? 11 : month-1)
  const cells = []
  for (let i = 0; i < firstDay; i++) cells.push({ day: daysInPrev - firstDay + i + 1, current: false, ds: null })
  for (let i = 1; i <= daysInMonth; i++) cells.push({ day: i, current: true, ds: dateStr(year, month, i) })
  while (cells.length % 7 !== 0) cells.push({ day: cells.length - firstDay - daysInMonth + 1, current: false, ds: null })

  // Build week days
  const weekDays = Array.from({length:7}, (_,i) => {
    const d = new Date(weekStart)
    d.setDate(d.getDate() + i)
    const ds = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`
    return { d, ds, label: DAYS[d.getDay()], num: d.getDate() }
  })

  // All upcoming events for list view
  const listEvents = events
    .filter(e => e.date >= today && filterTypes.includes(e.type))
    .sort((a,b) => a.date.localeCompare(b.date))

  return (
    <div style={{fontFamily:"'Montserrat',sans-serif"}}>

      {/* Add Event Modal */}
      {showAddModal && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.4)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:24}} onClick={()=>setShowAddModal(false)}>
          <div style={{background:'#fff',borderRadius:12,width:'100%',maxWidth:420,boxShadow:'0 8px 40px rgba(0,0,0,0.18)'}} onClick={e=>e.stopPropagation()}>
            <div style={{padding:'18px 24px',borderBottom:'1px solid #EDE6DA',background:'#2B2B2B',borderRadius:'12px 12px 0 0',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <div style={{fontFamily:'Georgia,serif',fontSize:16,fontWeight:600,color:'#fff'}}>Add Personal Reminder</div>
              <button onClick={()=>setShowAddModal(false)} style={{background:'none',border:'none',fontSize:20,cursor:'pointer',color:'rgba(255,255,255,0.5)',lineHeight:1}}>&times;</button>
            </div>
            <div style={{padding:'20px 24px',display:'flex',flexDirection:'column',gap:14}}>
              <div>
                <label style={labelStyle}>Title *</label>
                <input value={newEvent.title} onChange={e=>setNewEvent(n=>({...n,title:e.target.value}))} placeholder="Reminder title..." style={inputStyle}/>
              </div>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                <div>
                  <label style={labelStyle}>Date *</label>
                  <input type="date" value={newEvent.date} onChange={e=>setNewEvent(n=>({...n,date:e.target.value}))} style={inputStyle}/>
                </div>
                <div>
                  <label style={labelStyle}>Time (optional)</label>
                  <input value={newEvent.time} onChange={e=>setNewEvent(n=>({...n,time:e.target.value}))} placeholder="e.g. 2:00 PM" style={inputStyle}/>
                </div>
              </div>
              <div>
                <label style={labelStyle}>Notes (optional)</label>
                <textarea value={newEvent.note} onChange={e=>setNewEvent(n=>({...n,note:e.target.value}))} rows={2} placeholder="Any additional details..." style={{...inputStyle,resize:'none'}}/>
              </div>
              <div style={{display:'flex',justifyContent:'flex-end',gap:10,paddingTop:4,borderTop:'1px solid #EDE6DA'}}>
                <button onClick={()=>setShowAddModal(false)} style={{padding:'8px 16px',border:'1px solid #EDE6DA',borderRadius:6,background:'#fff',fontSize:12,fontWeight:600,color:'#4A4A4A',cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>Cancel</button>
                <button onClick={handleAddEvent} style={{padding:'8px 18px',background:accent,border:'none',borderRadius:6,color:'#fff',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>Add Reminder</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Day Detail Modal */}
      {showDayModal && selectedDay && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.4)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:24}} onClick={()=>setShowDayModal(false)}>
          <div style={{background:'#fff',borderRadius:12,width:'100%',maxWidth:460,maxHeight:'80vh',overflowY:'auto',boxShadow:'0 8px 40px rgba(0,0,0,0.18)'}} onClick={e=>e.stopPropagation()}>
            <div style={{padding:'18px 24px',borderBottom:'1px solid #EDE6DA',background:'#F7F2EB',borderRadius:'12px 12px 0 0',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <div style={{fontFamily:'Georgia,serif',fontSize:16,fontWeight:600,color:'#2B2B2B'}}>
                {new Date(selectedDay+'T12:00:00').toLocaleDateString('en-US',{weekday:'long',month:'long',day:'numeric'})}
              </div>
              <button onClick={()=>setShowDayModal(false)} style={{background:'none',border:'none',fontSize:20,cursor:'pointer',color:'#8A9E8A',lineHeight:1}}>&times;</button>
            </div>
            <div style={{padding:'16px 24px'}}>
              {eventsOn(selectedDay).length === 0 ? (
                <div style={{textAlign:'center',padding:'24px 0',color:'#8A9E8A',fontSize:13}}>No events on this day.</div>
              ) : eventsOn(selectedDay).map(e=>(
                <div key={e.id} style={{display:'flex',gap:12,padding:'12px 0',borderBottom:'1px solid #EDE6DA'}}>
                  <div style={{width:4,borderRadius:2,background:eventTypes[e.type].color,flexShrink:0,minHeight:40}}></div>
                  <div style={{flex:1}}>
                    <div style={{fontSize:13,fontWeight:600,color:'#2B2B2B',marginBottom:2}}>{e.title}</div>
                    <div style={{display:'flex',gap:8,alignItems:'center',flexWrap:'wrap'}}>
                      {e.time && <span style={{fontSize:11,color:'#6B7D6B'}}>&#128336; {e.time}</span>}
                      <span style={{fontSize:10,padding:'1px 6px',borderRadius:8,background:eventTypes[e.type].bg,color:eventTypes[e.type].color,fontWeight:600}}>{eventTypes[e.type].label}</span>
                    </div>
                    {e.note && <div style={{fontSize:11,color:'#8A9E8A',marginTop:4}}>{e.note}</div>}
                  </div>
                </div>
              ))}
              <button onClick={()=>{setShowDayModal(false);setNewEvent(n=>({...n,date:selectedDay}));setShowAddModal(true)}}
                style={{marginTop:14,width:'100%',padding:'9px',border:`1px dashed ${accent}`,borderRadius:6,background:'transparent',color:accent,fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
                + Add Personal Reminder
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      <div style={{marginBottom:16,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <div>
          <h1 style={{fontFamily:'Georgia,serif',fontSize:'1.4rem',color:'#2B2B2B',fontWeight:600}}>My Calendar</h1>
          <p style={{fontSize:11,color:'#6B7D6B',marginTop:2}}>Events, deadlines, and personal reminders</p>
        </div>
        <button onClick={()=>setShowAddModal(true)} style={{padding:'8px 18px',background:accent,border:'none',borderRadius:6,color:'#fff',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
          + Add Reminder
        </button>
      </div>

      {/* Upcoming deadlines banner */}
      {upcomingDeadlines.length > 0 && (
        <div style={{marginBottom:14,padding:'12px 16px',background:'rgba(160,57,43,0.05)',border:'1px solid rgba(160,57,43,0.2)',borderRadius:8,display:'flex',alignItems:'center',gap:16,flexWrap:'wrap'}}>
          <span style={{fontSize:11,fontWeight:700,color:'#A0392B',textTransform:'uppercase',letterSpacing:'0.08em',flexShrink:0}}>Upcoming Deadlines</span>
          {upcomingDeadlines.map(e=>(
            <div key={e.id} style={{display:'flex',alignItems:'center',gap:6}}>
              <span style={{fontSize:11,color:'#A0392B',fontWeight:600}}>{e.title}</span>
              <span style={{fontSize:10,color:'#8A9E8A'}}>&mdash; {new Date(e.date+'T12:00:00').toLocaleDateString('en-US',{month:'short',day:'numeric'})}</span>
            </div>
          ))}
        </div>
      )}

      {/* View + filter controls */}
      <div style={{display:'flex',gap:10,marginBottom:14,flexWrap:'wrap',alignItems:'center'}}>
        <div style={{display:'flex',background:'#fff',border:'1px solid #EDE6DA',borderRadius:8,overflow:'hidden'}}>
          {[['month','Month'],['week','Week'],['list','List']].map(([key,label],i,arr)=>(
            <button key={key} onClick={()=>setView(key)}
              style={{padding:'7px 18px',border:'none',borderRight:i<arr.length-1?'1px solid #EDE6DA':'none',background:view===key?accent:'#fff',color:view===key?'#fff':'#4A4A4A',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif",transition:'all 0.15s'}}>
              {label}
            </button>
          ))}
        </div>
        <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
          {Object.entries(eventTypes).map(([key,val])=>(
            <button key={key} onClick={()=>toggleFilter(key)}
              style={{padding:'4px 10px',border:`1px solid ${filterTypes.includes(key)?val.color:'#EDE6DA'}`,borderRadius:20,background:filterTypes.includes(key)?val.bg:'#fff',color:filterTypes.includes(key)?val.color:'#8A9E8A',fontSize:10,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif",transition:'all 0.15s'}}>
              {val.label}
            </button>
          ))}
        </div>
      </div>

      {/* MONTH VIEW */}
      {view === 'month' && (
        <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
          <div style={{padding:'12px 16px',borderBottom:'1px solid #EDE6DA',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
            <button onClick={prevMonth} style={{background:'none',border:'1px solid #EDE6DA',borderRadius:6,padding:'4px 12px',cursor:'pointer',fontSize:14,color:'#4A4A4A'}}>&#8592;</button>
            <div style={{fontFamily:'Georgia,serif',fontSize:16,fontWeight:600,color:'#2B2B2B'}}>{MONTHS[month]} {year}</div>
            <button onClick={nextMonth} style={{background:'none',border:'1px solid #EDE6DA',borderRadius:6,padding:'4px 12px',cursor:'pointer',fontSize:14,color:'#4A4A4A'}}>&#8594;</button>
          </div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',borderBottom:'1px solid #EDE6DA'}}>
            {DAYS.map(d=>(
              <div key={d} style={{textAlign:'center',padding:'8px 4px',fontSize:10,fontWeight:600,color:'#6B7D6B',letterSpacing:'0.08em',textTransform:'uppercase',borderRight:'1px solid #EDE6DA'}}>{d}</div>
            ))}
          </div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)'}}>
            {cells.map((cell,i)=>{
              const evs = cell.ds ? eventsOn(cell.ds) : []
              const isToday = cell.ds === today
              const isSelected = cell.ds === selectedDay
              return (
                <div key={i} onClick={()=>cell.ds&&handleDayClick(cell.ds)}
                  style={{minHeight:80,padding:'6px',borderRight:'1px solid #EDE6DA',borderBottom:'1px solid #EDE6DA',background:isToday?accentBg:isSelected?'rgba(184,115,74,0.05)':'#fff',cursor:cell.ds?'pointer':'default',transition:'background 0.1s',opacity:cell.current?1:0.35}}>
                  <div style={{fontSize:12,fontWeight:isToday?700:400,width:22,height:22,borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',background:isToday?accent:'transparent',color:isToday?'#fff':'#4A4A4A',marginBottom:3}}>
                    {cell.day}
                  </div>
                  {evs.slice(0,3).map((e,j)=>(
                    <div key={j} style={{fontSize:10,padding:'1px 4px',borderRadius:3,marginBottom:1,background:eventTypes[e.type].bg,color:eventTypes[e.type].color,fontWeight:500,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>
                      {e.title}
                    </div>
                  ))}
                  {evs.length > 3 && <div style={{fontSize:9,color:'#8A9E8A',marginTop:1}}>+{evs.length-3} more</div>}
                </div>
              )
            })}
          </div>
        </div>
      )}

      {/* WEEK VIEW */}
      {view === 'week' && (
        <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
          <div style={{padding:'12px 16px',borderBottom:'1px solid #EDE6DA',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
            <button onClick={prevWeek} style={{background:'none',border:'1px solid #EDE6DA',borderRadius:6,padding:'4px 12px',cursor:'pointer',fontSize:14,color:'#4A4A4A'}}>&#8592;</button>
            <div style={{fontFamily:'Georgia,serif',fontSize:15,fontWeight:600,color:'#2B2B2B'}}>
              Week of {weekDays[0].d.toLocaleDateString('en-US',{month:'short',day:'numeric'})} &mdash; {weekDays[6].d.toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'})}
            </div>
            <button onClick={nextWeek} style={{background:'none',border:'1px solid #EDE6DA',borderRadius:6,padding:'4px 12px',cursor:'pointer',fontSize:14,color:'#4A4A4A'}}>&#8594;</button>
          </div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',borderBottom:'1px solid #EDE6DA'}}>
            {weekDays.map(({d,ds,label,num})=>{
              const isToday = ds === today
              return (
                <div key={ds} style={{borderRight:'1px solid #EDE6DA',padding:'8px 6px',textAlign:'center',background:isToday?accentBg:'#F7F2EB'}}>
                  <div style={{fontSize:9,fontWeight:600,color:'#6B7D6B',textTransform:'uppercase',letterSpacing:'0.08em'}}>{label}</div>
                  <div style={{fontSize:16,fontWeight:isToday?700:400,color:isToday?accent:'#2B2B2B',fontFamily:'Georgia,serif'}}>{num}</div>
                </div>
              )
            })}
          </div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',minHeight:200}}>
            {weekDays.map(({ds})=>{
              const evs = eventsOn(ds)
              return (
                <div key={ds} onClick={()=>handleDayClick(ds)}
                  style={{borderRight:'1px solid #EDE6DA',padding:'8px 6px',cursor:'pointer',minHeight:200}}
                  onMouseEnter={e=>e.currentTarget.style.background='rgba(184,115,74,0.02)'}
                  onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                  {evs.map((e,i)=>(
                    <div key={i} style={{fontSize:10,padding:'3px 5px',borderRadius:4,marginBottom:4,background:eventTypes[e.type].bg,color:eventTypes[e.type].color,fontWeight:500,borderLeft:`2px solid ${eventTypes[e.type].color}`}}>
                      <div style={{fontWeight:600,marginBottom:1,lineHeight:1.3}}>{e.title}</div>
                      {e.time && <div style={{opacity:0.8}}>{e.time}</div>}
                    </div>
                  ))}
                  {evs.length === 0 && <div style={{fontSize:10,color:'rgba(107,125,107,0.3)',textAlign:'center',marginTop:20}}>--</div>}
                </div>
              )
            })}
          </div>
        </div>
      )}

      {/* LIST VIEW */}
      {view === 'list' && (
        <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
          <div style={{padding:'12px 16px',borderBottom:'1px solid #EDE6DA',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <div style={{fontFamily:'Georgia,serif',fontSize:15,fontWeight:600,color:'#2B2B2B'}}>Upcoming Events</div>
            <span style={{fontSize:11,color:'#6B7D6B'}}>{listEvents.length} events</span>
          </div>
          {listEvents.length === 0 ? (
            <div style={{padding:'40px',textAlign:'center',color:'#8A9E8A',fontSize:13}}>No upcoming events.</div>
          ) : (() => {
            let lastDate = null
            return listEvents.map(e => {
              const showHeader = e.date !== lastDate
              lastDate = e.date
              const dateLabel = new Date(e.date+'T12:00:00').toLocaleDateString('en-US',{weekday:'long',month:'long',day:'numeric'})
              return (
                <div key={e.id}>
                  {showHeader && (
                    <div style={{padding:'8px 16px',background:'#F7F2EB',borderBottom:'1px solid #EDE6DA',borderTop:'1px solid #EDE6DA',fontSize:11,fontWeight:600,color:'#6B7D6B',textTransform:'uppercase',letterSpacing:'0.1em'}}>
                      {e.date === today ? 'Today' : dateLabel}
                    </div>
                  )}
                  <div style={{display:'flex',gap:14,padding:'12px 16px',borderBottom:'1px solid #EDE6DA',alignItems:'flex-start'}}>
                    <div style={{width:4,minHeight:36,borderRadius:2,background:eventTypes[e.type].color,flexShrink:0,marginTop:2}}></div>
                    <div style={{flex:1}}>
                      <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start'}}>
                        <div style={{fontSize:13,fontWeight:600,color:'#2B2B2B'}}>{e.title}</div>
                        <span style={{fontSize:10,padding:'1px 7px',borderRadius:8,background:eventTypes[e.type].bg,color:eventTypes[e.type].color,fontWeight:600,flexShrink:0,marginLeft:8}}>{eventTypes[e.type].label}</span>
                      </div>
                      <div style={{display:'flex',gap:10,marginTop:3,flexWrap:'wrap'}}>
                        {e.time && <span style={{fontSize:11,color:'#6B7D6B'}}>&#128336; {e.time}</span>}
                        {e.note && <span style={{fontSize:11,color:'#8A9E8A'}}>{e.note}</span>}
                      </div>
                    </div>
                  </div>
                </div>
              )
            })
          })()}
        </div>
      )}
    </div>
  )
}
